module.exports = __webpack_public_path__ + "img/mobileintegratedImg.0685771a.png";